<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { snackbar, dialog } = storeToRefs(store)

const SetSnackbar = store.SetSnackbar
const SetDialog = store.SetDialog
</script>

<template>
    <div>
        <v-snackbar v-model="snackbar.visible" :color="snackbar.type">
            <template v-if="snackbar.icon">
                <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
            </template>
            <span v-html="snackbar.content"></span>
            <template v-slot:actions>
                <v-btn color="blue" variant="text" @click="SetSnackbar({visible:false,content:''})">Close</v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-model="dialog.visible" width="600">
            <v-card>
                <v-card-title>{{ dialog.title }}</v-card-title>
                <v-card-text>{{ dialog.content }}</v-card-text>
                <v-card-actions>
                    <v-btn color="darken-1" text @click="SetDialog({visible:false,title:'',content:''})" v-text="'Close'"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
